import { Config, Urls } from '@/config';
import { createContext, useContext } from 'react';

export const ConfigContext = createContext<{
  config: Config;
  backgroundImage: string;
  urls: Urls;
} | null>(null);

export const useConfig = () => {
  const context = useContext(ConfigContext);

  vtlog('useConfig:', context);

  if (context === null) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }

  return context;
};
